import { defineComponent as _defineComponent } from 'vue'
import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";
import { useSearchStore } from "@/pinia/search";
import { useRouter } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchButtons',
  emits: ["search", "clear"],
  setup(__props, { emit }) {

const router = useRouter();
const searchStore = useSearchStore();



const clear = () => {
  searchStore.resetSearch();
  router.replace({ params: {} }).catch(() => null);
  searchStore.$patch({ searchFormIsHidden: false });
  // re-focus the keyword search bar
  const keywordSearchRef = document.getElementById("autocomplete");
  if (keywordSearchRef) {
    keywordSearchRef.focus();
  }
  emit("clear");
};

return { __sfc: true,router, searchStore, emit, clear, NjBtn }
}

})